module.exports = __webpack_public_path__ + "img/katarina_bathrooms_8.d654ed8e.jpg";